export default {
  Farm: {
    header: {
      create_farm: 'Register farm',
      action_unauthorized: 'You are not allowed to do that',
      field_text_suggestion:
        'It is a good time to add the plots of your farm account',
      creation_question: 'Add plots?',
      farms: 'Farms',
    },
    import_fields_kml_card: {
      insufficient_coordinates: 'Field {0} has wrong coordinates',
      insufficient_polygons: 'Insufficient polygon quantity',
      warning:
        'KML format not known or not formatted with system especifications',
      no_field_latitude: 'Field {0} does not have latitudes',
      no_field_longitude: 'Field {0} does not have longitudes',
    },
    farm_card: {
      delete_farm_successfully: 'Farm deleted successfully',
      function_temporarily_unavailable: 'Function temporarily unavailable',
      delete_farm_warning:
        'By removing this farm, all associated programs will be lost and it will not be possible to revert',
      which_channel_to_contact:
        'Which channel would you like to get in touch with?',
      excluir: 'Delete',
      fields: 'Fields',
      she_disabled: 'Disabled',
      disable_farm_successfully: 'Farm disabled successfully.',
      enable_farm_successfully: 'Farm enabled successfully.',
    },
    add_farm_modal: {
      edit_farm: 'Edit farm',
      add_farm: 'Create farm',
      save_error: 'Error in saving farm',
      loading_error: 'Error in loading farms',
      city_error: 'Error in loading city',
      state_error: 'Error in loading state',
      warning_create_farm: 'When creating a farm you will be redirected to it',
      farm_name: 'Farm name',
      type_here: 'Type here',
      country: 'Country',
      select: 'Select',
      states: 'States',
      cities: 'Cities',
      required_price: 'Price is required',
    },
    fields_item_modal: {
      delete_field_warning:
        'This action is irreversible. Are you sure you want to remove this field?',
      enable_farm_error:
        'You can no longer enable farms or fields. If you still want to enable it, please contact our support team.',
      he_disabled: 'Disabled',
      disable_field_successfully: 'Field disabled successfully.',
      enable_field_successfully: 'Field enabled successfully.',
    },
    fields_modal: {
      add_fields: 'Register plot',
      total: 'Total',
      done: 'Done',
      map_new_fields: 'Map new fields',
      add_field_description:
        'You can add fields from the KML files, or by marking the field’s area',
      kml_format: 'KML files must be in Google format',
      load_kml: 'Load KML files',
      or: 'or',
    },
    maps_modal: {
      field_name: 'Field name',
      remove_point: 'Remove point',
      search_latitude: 'Search latitude',
      search_longitude: 'Search longitude',
      save_field_warning: 'To save the plot add at least 3 points on the map!',
      invalid_geometry:
        'Be careful, the plot design must follow a valid geometrical shape. Make the necessary adjustments to continue.',
      required_field: 'Required field',
      field_map: 'Field map',
      save: 'Save',
      action_unauthorized: 'You are not allowed to do that',
    },
    field_saved: 'Field saved successfully',
    msg_whatsapp_limit_enable_exceeded:
      '?text=Hello!+I+would+like+to+request+help+because+I+can+no+longer+enable+farms+and+fields.+I+use+the+account+{0}.',
    edit: 'Edit',
    enable: 'Enable',
    disable: 'Disable',
    enable_field_warning:
      "When disabling the field, you won't be able to create new sowings. Do you still want to continue?",
    disable_farm_warning:
      "When disabling the field, you won't be able to create new sowings. Do you still want to continue?",
    get_in_touch: 'Get in touch',
    area: 'Area',
    add: 'Add',
  },
}
